(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('validateCpf', ValidateCpf);

    function ValidateCpf() {

        function verifyCpf(cpf) {
            if (cpf) {
                cpf = cpf.replace(/[\.-]/g, "");

                var numbers, chars, sum, i, result, sameNumbers;
                sameNumbers = 1;

                if (cpf.length < 11)
                    return false;

                for (i = 0; i < cpf.length - 1; i++)
                    if (cpf.charAt(i) != cpf.charAt(i + 1)) {
                        sameNumbers = 0;
                        break;
                    }

                if (!sameNumbers) {
                    numbers = cpf.substring(0, 9);
                    chars = cpf.substring(9);
                    sum = 0;
                    for (i = 10; i > 1; i--)
                        sum += numbers.charAt(10 - i) * i;
                    result = sum % 11 < 2 ? 0 : 11 - sum % 11;
                    if (result != chars.charAt(0))
                        return false;
                    numbers = cpf.substring(0, 10);
                    sum = 0;
                    for (i = 11; i > 1; i--)
                        sum += numbers.charAt(11 - i) * i;
                    result = sum % 11 < 2 ? 0 : 11 - sum % 11;
                    if (result != chars.charAt(1))
                        return false;
                    return true;
                } else
                    return false;
            }
        }

        function link(scope, element, attrs, ctrl) {

            scope.$watch(attrs.ngModel, function (value) {

                if (verifyCpf(value))
                    ctrl.$setValidity('cpf', true);
                else
                    ctrl.$setValidity('cpf', false);

            })
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            link: link
        }
    }
}());